// Skip Wins Button

skipWinsButton = {};

skipWinsButton.create = function () {
  var button = new PIXI.Container();

  InputHelpers.addGenerics(button);

  button.canEnable = function () {
    let isAnimating =
      gameController.cashLinkPayout || gameController.countingMoons;

    if (!isAnimating) {
      isAnimating =
        gameController.isAnimatingWins() &&
        this._flags.platformEnabled &&
        !gameController.winSkipped;
    }

    return isAnimating;
  };

  button.canShow = function () {
    let isAnimating =
      gameController.cashLinkPayout || gameController.countingMoons;

    if (!isAnimating) {
      isAnimating =
        gameController.isAnimatingWins() &&
        this._flags.platformEnabled &&
        !gameController.winSkipped;
    }

    // if (gameController.buyABonusCashLink) {
    //   if (isAnimating) {
    //     isAnimating = !gameController.cashLinkSkip;
    //   }
    // }

    // if (gameController.inCoinAwardsModifier) {
    //   if (isAnimating) {
    //     isAnimating = !gameController.coinAwardsSkip;
    //   }
    // }

    return isAnimating;
  };

  button.onPressedCallback = function () {
    resourceManager.getController("inputOverlord").disableAll();

    if (
      gameController.buyABonusCashLink ||
      gameController.inCashLinkAwardDisplay ||
      gameController.inCoinAwardsModifier
    ) {
      resourceManager.get("slotContainer:powerPackAwardDisplay").skip();
      gameController.cashLinkSkip = false;
      gameController.coinAwardsSkip = false;
      gameController.cashLinkPayout = false;
      gameController.inCoinAwardsModifier = false;
      gameController.winSkipped = true;
    } else {
      gameController.skip();
    }

    if (button.soundName !== "") {
      button.playSound();
    }
  };

  button._flags.platformEnabled = false;
  button._flags.platformVisible = false;

  button.onConfig = function (config) {
    button._flags.platformEnabled = config.data.uiElements.btnSkip.enabled;
    button._flags.platformVisible = config.data.uiElements.btnSkip.visible;
  };

  messageBus.subscribe("spinner:GameConfigEvent", button.onConfig);

  return button;
};

skipWinsButton.initialise = function (json, object) {
  object.soundName = json.soundName || "";
};
skipWinsButton.getFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  "jjSkipWinsButton",
  skipWinsButton.create,
  skipWinsButton.initialise,
  skipWinsButton.getFilesRequired
);
